import { useEffect, useState } from "react";
export function useIntersectionObserver(elementRef, _a) {
    var _b = _a.threshold, threshold = _b === void 0 ? 0.3 : _b, _c = _a.root, root = _c === void 0 ? null : _c, _d = _a.rootMargin, rootMargin = _d === void 0 ? "0%" : _d, _e = _a.freezeOnceVisible, freezeOnceVisible = _e === void 0 ? false : _e;
    var elementThreshold = 0.05;
    var _f = useState(), entry = _f[0], setEntry = _f[1];
    var frozen = (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && freezeOnceVisible;
    var updateEntry = function (_a) {
        var entry = _a[0];
        setEntry(entry);
    };
    useEffect(function () {
        var hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || frozen)
            return;
        var observerParams = { threshold: elementThreshold, root: root, rootMargin: rootMargin };
        var observer;
        // Attaches the observer once elementRef.current exists. Mutating a ref never triggers
        // a re-render, so a component that mounts its ref'd element on a later render (e.g. once
        // async data arrives) would otherwise never get observed - watch the DOM until it appears.
        var tryAttach = function () {
            var node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
            if (!node)
                return false;
            observer = new IntersectionObserver(updateEntry, observerParams);
            observer.observe(node);
            return true;
        };
        if (tryAttach()) {
            return function () { return observer === null || observer === void 0 ? void 0 : observer.disconnect(); };
        }
        var mutationObserver = new MutationObserver(function () {
            if (tryAttach())
                mutationObserver.disconnect();
        });
        mutationObserver.observe(document.body, { childList: true, subtree: true });
        return function () {
            mutationObserver.disconnect();
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(elementThreshold), root, rootMargin, frozen]);
    return entry;
}
